/**
 * Interface para serviços de gerenciamento de permissões
 */

import { BasePlatformService } from './base_platform_service';

export enum PermissionType {
  NOTIFICATIONS = 'notifications',
  GEOLOCATION = 'geolocation',
  CAMERA = 'camera',
  MICROPHONE = 'microphone',
  CLIPBOARD_READ = 'clipboard-read',
  CLIPBOARD_WRITE = 'clipboard-write',
  FULLSCREEN = 'fullscreen',
  PERSISTENT_STORAGE = 'persistent-storage',
  BACKGROUND_SYNC = 'background-sync',
  PUSH = 'push'
}

export enum PermissionStatus {
  GRANTED = 'granted',
  DENIED = 'denied',
  PROMPT = 'prompt',
  UNSUPPORTED = 'unsupported'
}

export interface PermissionResult {
  status: PermissionStatus;
  canRequest: boolean;
  isSupported: boolean;
  timestamp: Date;
}

export interface IPermissionService extends BasePlatformService {
  readonly serviceName: 'Permission';
  
  checkPermission(type: PermissionType): Promise<PermissionResult>;
  requestPermission(type: PermissionType): Promise<PermissionResult>;
  checkMultiplePermissions(types: PermissionType[]): Promise<Map<PermissionType, PermissionResult>>;
  requestMultiplePermissions(types: PermissionType[]): Promise<Map<PermissionType, PermissionResult>>;
  getCachedPermissions(): Map<PermissionType, PermissionResult>;
  clearCache(): void;
}
